import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const CODECLIENT = process.env.REACT_APP_CODE_CLIENT;
const SHAI = process.env.REACT_APP_SHAI;

if (!API_URL) {
  // On préfère lancer une erreur explicite: plus facile à debug que des requêtes silencieuses sur undefined
  console.error("REACT_APP_API_URL n'est pas défini !");
}

/**
 * Instance axios configurée : baseURL, timeout, headers par défaut.
 * responseType: 'text' car le backend renvoie du XML SOAP en texte.
 */
const axiosInstance = axios.create({
  baseURL: API_URL || "",
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
  responseType: "text", // on attend du XML (texte) pour le parser côté client
});

// Fonction pour appeler l'API SOAP
export const postSoapRequest = async () => {
  if (!API_URL) {
    throw new Error("API_URL non configurée (REACT_APP_API_URL manquante).");
  }

  try {
    const body = {
      sSHA1: SHAI,
      codeClient: CODECLIENT,
      nStype: 0,
    };

    console.log("postSoapRequest body:", body);

    const response = await axiosInstance.post("/annonce/annonce-type", body);

    // response.data est une string XML (grâce à responseType: 'text')
    return response;
  } catch (error) {
    console.error("Erreur lors de l'appel postSoapRequest:", error);
    // Rejeter pour que l'appelant gère (component)
    throw error;
  }
};

export const createOrUpdatePourcentage = async (type_annonce: string, remise: number) => {
  if (!API_URL) throw new Error("API_URL non configurée.");
  try {
    const response = await axiosInstance.post("/pourcentage/creation", {
      type_annonce,
      remise,
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la création ou mise à jour du pourcentage", error);
    throw error;
  }
};

export const getPourcentageByTypeAnnonce = async (type_annonce: string) => {
  if (!API_URL) throw new Error("API_URL non configurée.");
  try {
    const response = await axiosInstance.get(`/pourcentage/${encodeURIComponent(type_annonce)}`);
    return response.data;
  } catch (error) {
    console.error(`Erreur lors de la récupération du pourcentage pour le type d'annonce: ${type_annonce}`, error);
    throw error;
  }
};
